/**
 * badge.service.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Injectable } from "@angular/core";
import { ConfigurationService } from "../configuration/configuration.service";
import { Badge, BadgeEntry, OverlayEntry } from "./badge";

@Injectable()
export class BadgeService
{
    private badges : Map<string, Badge> = new Map<string, Badge>();
    private overlays : Map<string, string> = new Map<string, string>();

    constructor (protected config : ConfigurationService)
    {
        this.config.reports.overlays.forEach((o : OverlayEntry) =>
            this.overlays.set(o.name, o.image));
        this.config.reports.badges.forEach((b : BadgeEntry) => {
            const badge : Badge = new Badge(
                b.report,
                this.config.reports.root + b.image,
                b.overlay,
                this.overlays.get(b.overlay)
            );
            this.badges.set(badge.name, badge);
        });
    }

    public get (name : string) : Badge
    {
        if (this.badges.has(name))
        {
            return this.badges.get(name);
        }
        return Badge.UNKNOWN;
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/badge.service.ts